import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromOperationInternalEvent from '../operation-internal-event/operation-internal-event.reducer'
import { OperationInternalEventFormComponent } from './form/form.component'
import { OperationInternalEventGeneralTabComponent } from './general-tab/show.component'
import { OperationInternalEventIndexComponent } from './index/index.component'
import { OperationInternalEventRoutingModule } from './operation-internal-event-routing.module'
import { OperationInternalEventEffects } from './operation-internal-event.effects'
import { OperationInternalEventSerializer } from './operation-internal-event.serializer'
import { OperationInternalEventService } from './operation-internal-event.service'
import { OperationInternalEventShowComponent } from './show/show.component'
import { OperationInternalEventTableComponent } from './table/table.component'
import { OperationInternalEventCreateComponent } from './create/show.component'
import { TagModule } from '../../tag/tag.module'
import { SubscriptionModule } from '../../subscription/subscription.module'
import { InternalEventModule } from '../../internal-event/internal-event.module'
import { ProductModule } from '../../product/product.module'
import { CourseModule } from '../../course/course.module';

@NgModule({
    imports: [
        OperationInternalEventRoutingModule,
        TagModule,
        SharedModule,
        StoreModule.forFeature(fromOperationInternalEvent.FEATURE_NAME, fromOperationInternalEvent.operationInternalEventReducer),
        EffectsModule.forFeature([OperationInternalEventEffects]),
        InternalEventModule,
        CourseModule,
        SubscriptionModule,
        ProductModule
    ],
    declarations: [
        OperationInternalEventIndexComponent,
        OperationInternalEventFormComponent,
        OperationInternalEventTableComponent,
        OperationInternalEventShowComponent,
        OperationInternalEventGeneralTabComponent,
        OperationInternalEventCreateComponent
    ],
    exports: [
        OperationInternalEventTableComponent,
        OperationInternalEventIndexComponent
    ],
    providers: [
        OperationInternalEventService,
        {
            provide: OperationInternalEventSerializer,
            useClass: OperationInternalEventSerializer
        }
    ]
})
export class OperationInternalEventModule {}
